// extracted by mini-css-extract-plugin
export var arrow = "SearchResults-module--arrow--8df51";
export var arrowNo = "SearchResults-module--arrow_no--095ce";
export var arrowYes = "SearchResults-module--arrow_yes--860dc";
export var flex = "SearchResults-module--flex--e97f6";
export var flex1 = "SearchResults-module--flex_1--aa5f7";
export var flexCenter = "SearchResults-module--flex_center--8e000";
export var flexCenterCol = "SearchResults-module--flex_center_col--716bc";
export var flexCol = "SearchResults-module--flex_col--db339";
export var flexFixCenterCol = "SearchResults-module--flex_fix_center_col--84cf2";
export var flexFixedCenterCol = "SearchResults-module--flex_fixed_center_col--71917";
export var noResultsFoundTitle = "SearchResults-module--noResultsFoundTitle--aa4f0";
export var pageIndicator = "SearchResults-module--pageIndicator--cd9f7";
export var resultInformationRow = "SearchResults-module--resultInformationRow--7eb0e";
export var resultsIndicator = "SearchResults-module--resultsIndicator--117e9";
export var rotating = "SearchResults-module--rotating--dad3e";
export var searchResultsPagination = "SearchResults-module--searchResultsPagination--4f80c";
export var sortResultsDropdownContainer = "SearchResults-module--sortResultsDropdownContainer--fc31e";
export var sortResultsLabel = "SearchResults-module--sortResultsLabel--65e97";
export var suggestTopics = "SearchResults-module--suggestTopics--79ec8";